exports.blankAdpForm = Object.freeze({
  info: {
    "section2a-show": false,
    "section2b-show": false,
    "section2c-show": false,
    "section2d-show": false,
    "section1-touched": false,
    "section2-touched": false,
    "section3-touched": false,
    "section4Alt-touched": false,
    "section4-touched": false,
    "section2a-touched": false,
    "section2b-touched": false,
    "section2c-touched": false,
    "section2d-touched": false,
  },
  section1: {
    cep: null,
    dob: "",
    sex: [],
    LTCH: "",
    city: "",
    benefits: null,
    coverage: [],
    "home-tel": "",
    extension: "",
    "last-name": "",
    "first-name": "",
    "health-card": "",
    "postal-code": "",
    "street-name": "",
    "unit-number": "",
    "business-tel": "",
    "version-code": "",
    "street-number": "",
    "middle-initial": "",
    "type-of-benefit": null,
    "lot-concession-rural": "",
  },
  section2: {
    "mobility-status": "",
    "devices-required": [],
    "medical-condition": "",
    "previous-equipment": [],
  },
  section3: {
    date: "",
    "applicant-or-agent": "",
  },
  section4Alt: {
    sections: [],
    attachments: [],
  },
  section4: {
    "authorizer-extension": "",
    "authorizer-last-name": "",
    "authorizer-first-name": "",
    "authorizer-assessment-date": "",
    "adp-authorizer-registration-number": "",
    "authorizer-business-telephone-number": "",
    "attachment-justification-funding-chart": false,
    "attachment-special-circumstances": false,
    "attachment-vendor-quote-custom-mods": false,
    "attachment-vendor-quote-replacement": false,
    "s1": false,
    "s2a": false,
    "s2b": false,
    "s2c": false,
    "s2d": false,
    "s3s4": false
  },
  section2a: {
    brakes: null,
    "brake-type": null,
    costLabour: null,
    "hand-grips": null,
    "wheel-size": null,
    "base-device": [],
    "seat-height": "",
    "back-support": null,
    "client-weight": "",
    "seat-height-na": false,
    "number-of-wheels": null,
    "push-handle-units": null,
    "seat-height-units": null,
    "push-handle-height": "",
    "width-push-handles": "",
    "client-weight-units": null,
    "forearm-attachments": null,
    "replacement-devices": [],
    "width-between-units": null,
    "independently-mobile": null,
    "move-beyond-residence": null,
    "reason-for-application": null,
    "specific-standing-frame": null,
    "move-through-inaccessible": null,
    "move-throughout-residence": null,
    "requires-forearm-crutches": null,
    "additional-adp-funded-options": [],
    "custom-modifications-required": null,
    "custom-modifications-clinical-rationale": null,
    "setup-instructions-for-vendor": [],
    "non-adp-funded-options-prescribed": [],
  },
  section2b: {
    "seat-depth": "",
    "seat-width": "",
    anticipated: null,
    "back-height": "",
    "base-device": null,
    "power-addon": false,
    "client-weight": "",
    "seat-to-floor": "",
    "leg-rest-length": "",
    "back-cane-height": "",
    "seat-depth-units": null,
    "seat-width-units": null,
    "back-height-units": null,
    "some-power-beyond": null,
    "client-weight-units": null,
    "intolerance-sitting": null,
    "replacement-devices": [],
    "seat-to-floor-units": null,
    "history-tissue-trauma": null,
    "leg-rest-length-units": null,
    "move-beyond-dependent": null,
    "move-beyond-residence": null,
    "some-power-throughput": null,
    "back-cane-height-units": null,
    "reason-for-application": null,
    "move-independently-beyond": null,
    "move-throughout-dependent": null,
    "move-throughout-residence": null,
    "weight-shift-independently": null,
    "maintain-functional-posture": null,
    "additional-adp-funded-options": [],
    "custom-modifications-required": null,
    "move-independently-throughout": null,
    "provide-clinical-rationale": "",
    "setup-instructions-for-vendor": [],
    "non-adp-funded-options-prescribed": [],
  },
  section2c: {
    "seat-depth": "",
    "seat-width": "",
    "base-device": null,
    "client-weight": "",
    "leg-rest-length": "",
    "seat-depth-units": null,
    "seat-width-units": null,
    "speciality-options": [],
    "medical-condition": "",
    "client-weight-units": null,
    "replacement-devices": [],
    "scooter-seat-tiller": null,
    "finished-back-height": "",
    "leg-rest-length-units": null,
    "reason-for-application": null,
    "power-positioning-devices": [],
    "base-move-beyond-residence": null,
    "finished-back-height-units": null,
    "finished-seat-to-floor-units": null,
    "additional-adp-funded-options": [],
    "custom-modifications-required": null,
    "finished-seat-to-floor-height": "",
    "scooter-move-beyond-residence": null,
    "setup-instructions-for-vendor": [],
    "base-move-throughout-residence": null,
    "non-adp-funded-options-prescribed": [],
    "scooter-move-throughout-residence": null,
  },
  section2d: {
    tray: [],
    "back-cover": false,
    "arm-support": [],
    "back-support": [],
    "seat-cushion": [],
    "seat-options": [],
    "tray-options": [],
    "back-hardware": [],
    "requires-tray": null,
    "seat-hardware": [],
    "lateral-support": [],
    "pommel-hardware": false,
    "foot-leg-support": [],
    "pommel-adductors": [],
    "complete-assembly": [],
    "headrest-neckrest": [],
    "positioning-belts": [],
    "seat-cushion-cover": [],
    "seating-components": null,
    "arm-support-options": [],
    "replacement-devices": [],
    "arm-support-hardware": [],
    "back-support-options": [],
    "reason-for-application": [],
    "lateral-support-options": false,
    "foot-leg-support-options": [],
    "lateral-support-hardware": false,
    "positioning-belt-options": false,
    "foot-leg-support-hardware": [],
    "headrest-neckrest-options": false,
    "headrest-neckrest-hardware": [],
    "custom-modifications-required": null,
    "setup-instructions-for-vendor": [],
    "non-adp-funded-options-prescribed": [],
  },
});
